export default "cashdesk";



// WEBPACK FOOTER //
// ./src/assets/enum/whitelabel/mhi/index.js